<template>
    <div>
        <select id="content_type" name="content_type" class="form-control" v-on:change="changeContent()" v-model="selectedContentType">
            <option value="">Geen type geselecteerd</option>
            <option v-for="(contentTypeKey, contentTypeLabel) in contentTypes" v-text="contentTypeKey" :value="contentTypeLabel"></option>
        </select>

        <select id="content_id" name="content_id" class="form-control" v-show="Object.keys(currentOptions).length > 0" v-model="selectedContent">
            <option value="">Kies content</option>
            <option v-for="(content, id) in currentOptions" v-text="content" :value="id"></option>
        </select>
    </div>
</template>

<script>
export default {
    name: "ContentTypeManager",

    props: {
        contentTypes: {
            required: true,
            type: Object
        },
        contentOptions: {
            required: true,
            type: Object,
            default: {},
        },
        currentType: {
            required: false,
            default: "",
        },
        currentContent: {
            required: false,
            default: "",
        }
    },
    data () {
        return {
            selectedContentType: "",
            selectedContent: "",
            currentOptions: []
        }
    },
    methods: {
        changeContent(){
            if(this.selectedContentType !== "") {
                this.currentOptions = this.contentOptions[this.selectedContentType];
            }
            else{
                this.currentOptions = [];
                this.selectedContent = "";
            }
        },
    },
    mounted () {
        if(this.currentType !== "") {
            this.selectedContentType = this.currentType;
            if(Object.keys(this.contentOptions[this.selectedContentType]).length > 0){
                this.changeContent();
            }
        }

        if(this.currentContent !== ""){
            this.selectedContent = this.currentContent;
        }
    }
}
</script>

<style scoped>

</style>
